import { render } from "./PaginaRingraziamento.vue?vue&type=template&id=223cd443"
import script from "./PaginaRingraziamento.vue?vue&type=script&lang=js"
export * from "./PaginaRingraziamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__